import { moveItemInArray } from "@angular/cdk/drag-drop";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SafeResourceUrl } from "@angular/platform-browser";
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import { ModalDismissReasons, NgbDateStruct, NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { DirtyCheckComponent } from "src/app/_models/dirty-check.component";
import { DateUtilsService } from "src/app/_services/dateUtils";
import { InvoiceService } from "./../../../../_services/invoice.service";

@Component({
  selector: "app-ds-ledger-preview",
  templateUrl: "./ds-ledger-preview.component.html",
  styleUrls: ["./ds-ledger-preview.component.scss"],
})
export class DsLedgerPreviewComponent implements OnInit, DirtyCheckComponent {
  docs: any;

  invoiceDetails: any;
  invoiceType: any;
  closeResult: string = "";
  modalOptions: NgbModalOptions;
  loading: boolean = false;
  invoiceSaved: boolean = false;
  uploadInvoice: boolean = false;
  uploadSuccessful: boolean = false;
  saving: boolean = false;
  displayName: any;
  hasError = false;
  safeUrl: SafeResourceUrl = "";
  pdfSrc: any;
  fileLink: any;
  fileSizeError = false;
  fileTypeError = false;
  typeError = false;
  sizeError = false;
  supportingDocuments: any[] = [];
  agreed = [{ status: false }];
  invoiceFile: any;
  invoiceDataToSave: any;
  isInvoiceChange: boolean = false;
  isUpdatedData: boolean = false;
  invoiceChanged: boolean = false;
  responseData: any;
  isCondensed: boolean = false;
  currentLayout = {
    isCondensed: true,
  };
  barcodeNo: any;
  eInvoice = false;
  reqData: any;
  formData: any;
  DocDt: NgbDateStruct;
  model: NgbDateStruct;
  irnExist: boolean = false;
  dsLoaderMsg = "";
  formSubmitted = false;
  previousUrl: any;
  companies: any;
  organisations: any;
  configResCompanies: any;
  configResOrg: any;
  configResDocs: any;
  totalSizeError = false;
  files: File[];
  supportingDocsAdded = false;
  canSubmitForm = false;
  allDeleted = false;
  emptyPo = false;
  poNo: any;

  extractedLedger = new FormGroup({
    SellerGstin: new FormControl("", [Validators.required, Validators.minLength(15), Validators.maxLength(15)]),
    file_link: new FormControl(""),
    BuyerGstin: new FormControl(""),
    DocNo: new FormControl("", [Validators.required]),
    DocTyp: new FormControl(""),
    DocDt: new FormControl("", [Validators.required]),
    TotInvVal: new FormControl(null, [Validators.required]),
    ItemCnt: new FormControl(""),
    Irn: new FormControl("", [Validators.minLength(64), Validators.maxLength(64)]),
    IrnDt: new FormControl(""),
    MainHsnCode: new FormControl(""),
    file: new FormControl(""),
    supportingFiles: new FormControl([]),
    fileSource: new FormControl(""),
    documentSource: new FormControl(""),
    poNo: new FormControl(""),
    terms_agreed: new FormControl(false),
    emailAddress: new FormControl("", [Validators.required, Validators.email, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]),
    username: new FormControl(""),
    userID: new FormControl(""),
    companyCode: new FormControl("", [Validators.required]),
    purchaseOrg: new FormControl("", [Validators.required]),
    docType: new FormControl("", [Validators.required]),
  });

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private invoiceService: InvoiceService,
    private authService: AuthService,
    private dateUtils: DateUtilsService
  ) {
    this.modalOptions = {
      backdrop: "static",
      backdropClass: "customBackdrop",
      scrollable: true,
    };

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        this.previousUrl = val.url;
      }
    });
  }

  setAsDirty() {
    this.extractedLedger.controls["Irn"].markAsDirty;
  }

  toggleSidebar() {
    this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
    document.body.setAttribute("data-sidebar-size", this.currentLayout.isCondensed ? "condensed" : "default");
  }

  selectDocuments(event: any) {
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
    const MAX_TOTAL_SIZE = 25 * 1024 * 1024; // 25MB
    const ALLOWED_TYPES = ["application/pdf"];

    this.files = Array.from(event);
    // Calculate the total size of the selected files (in bytes)
    const totalSize = this.files.reduce((sum, file) => sum + file.size, 0);

    // Check if the total size exceeds 25 MB
    if (totalSize > MAX_TOTAL_SIZE) {
      this.totalSizeError = true;
      this.sizeError = false;
      this.typeError = false;
    }

    for (const file of this.files) {
      // Check if any individual file size exceeds 5 MB
      if (file.size > MAX_FILE_SIZE) {
        this.sizeError = true;
        this.typeError = false;
        this.totalSizeError = false;
        continue;
      }

      // Filter out any files that are not Word, Excel, or PDF
      if (!ALLOWED_TYPES.includes(file.type)) {
        this.typeError = true;
        this.sizeError = false;
        this.totalSizeError = false;
        continue;
      }
      this.supportingDocuments.push(file);
    }

    if (this.allDeleted === true) {
      if (this.extractedLedger.get("terms_agreed").value === true) {
        this.extractedLedger.patchValue({
          terms_agreed: false,
        });
      }
    } else {
      this.extractedLedger.patchValue({ terms_agreed: false });
    }

    this.supportingDocsAdded = true;
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.supportingDocuments.splice(index, 1);

    if (this.supportingDocuments.length === 0) {
      if (this.extractedLedger.get("terms_agreed").value === true) {
        this.extractedLedger.patchValue({
          terms_agreed: false,
        });
      }

      this.canSubmitForm = false;
      this.allDeleted = true;
      this.supportingDocsAdded = false;
    }
  }

  checkSupportingDocuments() {
    if (this.supportingDocuments.length > 0 && this.extractedLedger.get("terms_agreed").value === false) {
      this.canSubmitForm = true;
    } else {
      this.canSubmitForm = false;
    }
  }

  canDeactivate() {
    if (!this.formSubmitted) {
      this.loading = true;
      return false;
    } else {
      return true;
    }
  }

  exitForm() {
    this.loading = false;
    this.formSubmitted = true;
    this.router.navigateByUrl(this.previousUrl);
  }

  cancelExit() {
    this.loading = false;
  }

  onDrop(event: any) {
    // Update the list order
    moveItemInArray(this.supportingDocuments, event.previousIndex, event.currentIndex);
    this.supportingDocsAdded = true;
  }

  open(content: any) {
    this.modalService.open(content, this.modalOptions).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
  reUploadInvoice(event: any) {
    if (event.length > 0) {
      const fileUploaded = event[0];

      //console.log(fileUploaded);

      if (fileUploaded.type !== "application/pdf") {
        this.hasError = false;
        this.fileSizeError = false;
        this.fileTypeError = true;
      } else if (fileUploaded.size > 5042157) {
        this.fileTypeError = false;
        this.hasError = false;
        this.fileSizeError = true;
      } else {
        this.fileSizeError = false;
        this.fileTypeError = false;

        if (typeof FileReader !== "undefined") {
          let reader = new FileReader();
          reader.onload = (e: any) => {
            this.pdfSrc = e.target.result;
            //console.log(this.pdfSrc);
          };
          let $file: any = fileUploaded;
          reader.readAsArrayBuffer($file);
        }

        this.extractedLedger.patchValue({
          fileSource: fileUploaded,
        });

        this.hasError = false;
        this.isInvoiceChange = true;
        this.loading = true;
        this.formSubmitted = true;
        this.invoiceChanged = true;
        //console.log(localStorage.getItem("eippSession"));

        const formData: any = new FormData();
        // formData.append('poNo', this.route.snapshot.params['poNo']);
        formData.append("sellerCode", localStorage.getItem("vendorCode"));
        formData.append("sessionId", localStorage.getItem("eippSession"));
        formData.append("file", this.extractedLedger.value.fileSource);

        this.dsLoaderMsg = "Verifying Signature";

        setTimeout(() => {
          this.dsLoaderMsg = "Authenticating Signature";
        }, 5000);
        setTimeout(() => {
          this.dsLoaderMsg = "Extracting Data";
        }, 10000);
        setTimeout(() => {
          this.dsLoaderMsg = "Validating Data";
        }, 15000);

        this.invoiceService.verifyDigitalSignature(formData).subscribe(
          (res) => {
            this.loading = false;
            this.formSubmitted = false;
            this.invoiceChanged = false;
            this.responseData = res;
            //console.log(res);
            if (this.responseData.length !== 0 && this.responseData.status === "error") {
              //console.log(this.responseData.msg);
              this.hasError = true;
            } else {
              //console.log("Success hereresponseData");
              //console.log(this.responseData);
              this.formData = this.responseData.data;
              if (typeof this.formData.irn !== "undefined") {
                this.irnExist = true;
              } else {
                this.irnExist = false;
              }
              this.extractedLedger.patchValue({
                SellerGstin: this.formData.vendorGSTIN,
                DocNo: this.formData.invoiceNumber,
                DocDt: this.formData.invoiceDate.replaceAll(".", "/"),
                TotInvVal: this.formData.invoiceAmount,
                Irn: this.formData.irn,
              });
              this.fileLink = this.responseData.file_link;
              this.hasError = false;

              this.fileLink = this.responseData.file_link;
              this.hasError = false;
            }
          },
          (error) => {
            console.log(error.msg);
          }
        );
      }
    }
  }

  onSubmitDigitalInvoice() {
    this.loading = true;
    this.uploadInvoice = true;
    this.formSubmitted = true;

    this.poNo = localStorage.getItem("poNo");
    const lineItems = localStorage.getItem("pods");

    const convertPods = JSON.parse(lineItems);
    const poItems: any = [];

    convertPods.forEach((p: any) => {
      if (p.docNo !== "" || typeof p.docNo !== "undefined") {
        poItems.push({
          poNo: p.poNo,
          itemNo: p.poLineNo,
          grn: p._id,
        });
      } else {
        poItems.push({
          poNo: p.poNo,
          itemNo: p.poLineNo,
          grn: "",
        });
      }
    });

    let companyCode = "";
    let purchaseOrg = "";
    let docType = "";

    if (convertPods[0].docNo !== "") {
      companyCode = convertPods[0].cmpCode;
      purchaseOrg = convertPods[0].purchaseOrg;
      docType = convertPods[0].erpDocType;
    } else {
      companyCode = localStorage.getItem("servCompanyCode");
      purchaseOrg = localStorage.getItem("servPurchaseOrg");
      docType = localStorage.getItem("servDocType");
    }

    const userData = {
      req: {
        companyCode: companyCode,
        purchaseOrg: purchaseOrg,
        docType: docType,
        items: poItems,
      },
    };

    if (this.isInvoiceChange === true) {
      this.invoiceFile = this.extractedLedger.value.fileSource;
    } else {
      this.invoiceFile = this.invoiceService.getFileElement();
    }

    const fileOrder = [];
    this.supportingDocuments.forEach((file, index) => {
      const obj = {};
      obj[(index + 1).toString()] = file.name;
      fileOrder.push(obj);
    });

    const currentUser = this.authService.getCurrentUser();
    const session = currentUser.eippSessionData.data.session;

    const led = this.invoiceService.getDataDigitalInvoice();
    const timestamp = Date.now();

    const ledger = [
      {
        docDate: this.dateUtils.formatDateString(this.extractedLedger.get("DocDt").value),
        dueDate: this.dateUtils.formatDateString(this.extractedLedger.get("DocDt").value),
        dueAmt: parseFloat(this.extractedLedger.value.TotInvVal),
        docAmt: parseFloat(this.extractedLedger.value.TotInvVal),
        docType: "APINV",
        poNo: led.poNo,
        docNo: this.extractedLedger.get("DocNo").value,
        timestamp: timestamp,
        currCode: "INR",
        status: "PENDING_SUBMISSION",
        barcodePrefix: this.invoiceDetails.barcodePrefix,
        supplierNm: localStorage.getItem("displayName"),
        docDetail: {
          docAmt: this.extractedLedger.get("TotInvVal").value,
          docFormat: "ds-invoice",
          docCat: "po_based",
          docGstin: this.extractedLedger.get("SellerGstin").value,
          irn: this.extractedLedger.get("Irn").value,
        },
        docRef: [
          {
            src: this.invoiceDetails.file_link,
          },
        ],
        lineItemDetail: [
          // {
          //   poLineNo: convertPods[0].poLineNo,
          //   grn: convertPods[0]._id,
          //   grnNo: convertPods[0].docNo,
          // },
        ],
        supplierCode: convertPods[0].supplierCode[0],
        cmpCode: convertPods[0].cmpCode,
        purchaseOrg: convertPods[0].purchaseOrg,
        erpDocType: convertPods[0].erpDocType,
        email: led.email,
      },
    ];

    const formData: any = new FormData();
    formData.append("sellerCode", this.authService.getSellerCode());
    formData.append("reqType", "payexap");
    formData.append("session", JSON.stringify(session));
    formData.append("action", "add");
    formData.append("ledger", JSON.stringify(ledger));

    if (this.supportingDocuments.length !== 0) {
      for (let i = 0; i < this.supportingDocuments.length; i++) {
        formData.append("supportingDocs", this.supportingDocuments[i]);
      }
    } else {
      formData.append("supportingDocs", this.supportingDocuments);
    }

    this.invoiceService.uploadInvoiceWithoutExtration(formData).subscribe(
      (res) => {
        this.responseData = res;
        if (this.responseData.status === "error") {
          console.log("error exist");
          this.loading = false;
          this.uploadInvoice = false;
          this.hasError = true;
          this.formSubmitted = false;
        } else {
          this.barcodeNo = this.responseData.barcode;
          this.uploadInvoice = false;
          this.invoiceSaved = false;
          this.uploadSuccessful = true;
        }
      },
      (error) => {
        this.loading = false;
        this.uploadInvoice = false;
        this.hasError = true;
        this.formSubmitted = false;
        console.log(error);
      }
    );
  }

  getAllConfig() {
    const config: any = this.invoiceService.getAllConfig();
    this.organisations = config.purchaseOrganizations;
    this.companies = config.companyCodes;
    this.docs = config.purchaseDoc;
    console.log(this.docs, "this.docs");
  }

  ngOnInit(): void {
    this.displayName = localStorage.getItem("displayName");
    this.invoiceDetails = this.invoiceService.getDataDigitalInvoice();
    this.loadFile();
    this.formSubmitted = false;

    this.fileLink = this.invoiceService.fileUrl;

    this.formData = this.invoiceService.getDataDigitalInvoice();
    console.log(this.formData, "this.formData");

    if (typeof this.formData.irn !== "undefined") {
      this.irnExist = true;
    }

    let documentDate;
    if (typeof this.formData.invoiceDate !== "undefined") {
      documentDate = this.formData.invoiceDate.replaceAll(".", "/");
    } else {
      documentDate = "";
    }

    this.extractedLedger.patchValue({
      SellerGstin: this.formData.gstin,
      DocNo: this.formData.invoice_number,
      DocDt: this.formData.invoice_date,
      TotInvVal: this.formData.invoice_amount,
      Irn: this.formData.irn,
      companyCode: this.invoiceDetails.cmpCode,
      purchaseOrg: this.invoiceDetails.purchaseOrg,
      docType: this.invoiceDetails.erpDocType,
      username: this.invoiceService.getUsername(),
      userID: this.invoiceService.getUserId(),
      emailAddress: this.invoiceDetails.email,
      poNo: this.invoiceDetails.poNo,
    });

    this.getAllConfig();

    this.setAsDirty();
  }

  closeSuccessDialog() {
    this.loading = false;
    this.router.navigateByUrl("/credit-notes");
  }

  resubmitInvoice() {
    const poNo = this.route.snapshot.params["poNo"];
    this.router.navigate(["/submit-invoice", poNo]);
  }

  loadFile() {
    if (typeof FileReader !== "undefined") {
      let reader = new FileReader();
      reader.onload = (e: any) => {
        this.pdfSrc = e.target.result;
        //console.log(this.pdfSrc);
      };
      let $file: any = this.invoiceService.getFileElement();
      reader.readAsArrayBuffer($file);
    }
  }

  onCheckboxChange(e: any) {
    //console.log(e);

    if (e.target.checked) {
      this.extractedLedger.patchValue({
        terms_agreed: e.target.value,
      });
    } else {
      this.extractedLedger.patchValue({
        terms_agreed: null,
      });
    }
  }
}
